module.exports = __webpack_public_path__ + "static/media/30OIOS9.3acb9dfa.jpg";